<template>
  <div class="main-wrap">
    <div id="main-content">
      <div class="wrapper">
        <jm-crumbs/>
        <div class="table-agile-info">
          <div class="common-new-title mode2">
            <span>部门列表</span>
          </div>
          <el-alert style="margin: 10px 0" show-icon type="warning" title="部门管理请到用户列表页进行维护"></el-alert>
          <jm-tableList
            url="/index/Power/departmentIndex"
            no-pagination
            :refresh.sync="refresh">
          </jm-tableList>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
import crumbs from '@/components/tool/crumbs.vue';
import toolbar from '@/components/tool/toolbar.vue';
import tableList from '@/components/data/tableList.vue';

export default {
  data() {
    return {
      refresh: false,
    };
  },
  components: {
    'jm-crumbs': crumbs,
    'jm-toolbar': toolbar,
    'jm-tableList': tableList,
  },
  computed: {},
  methods: {},
  watch: {},
};
</script>
<style scoped>
</style>
